import { Injectable } from '@angular/core';
import { Environment } from '@r1-compass-library/environments/environment';
import { PlayFolder } from '@r1-compass-library/models';
import { FolderRestService } from './rest/folder-rest.service';
import { BasicFolderSearch } from '@r1-compass-library/models/search/basic-folder-search.model';

@Injectable({ providedIn: 'root' })
export class PlayFolderService extends FolderRestService<PlayFolder, BasicFolderSearch> {
    protected override BASE_URL: string = Environment.baseUrl + '/frontend/play-folders';
    protected override TARGET_OBJECT = 'play-folder';

    processNamePrefix = 'PlayFolderService';
}
